// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ArrowNarrowRightIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ArrowNarrowRight/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m17 8 4 4m0 0-4 4m4-4H3"
}));
export default ArrowNarrowRightIcon;